import React from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import * as quotationCrud from '../../../../crud/quotation.crud';
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import { getQuoteBadgeVariantByStatus } from './ListAll';
import BaseListPage from '../../_CustomComponents/BaseListPage';

export const getBatchFormFields = (fields, replyFields, intl) => {
    const formFields = [];
    formFields.push({
        caption: "Compensation Event",
        dataField: 'compensationreference',
        required: true,
        dataType: 'string',
    })
    if (fields.Title.visible) {
        formFields.push({
            caption: fields.Title.label,
            dataField: 'quotereference',
            required: fields.Title.required,
            dataType: 'string',
        })
    }
    if (fields.ContinuingEffect.visible) {
        formFields.push({
            caption: fields.ContinuingEffect.label,
            dataField: 'continuingeffect',
            required: fields.ContinuingEffect.required,
            dataType: 'list',
            options: {
                dataSource: fields.ContinuingEffect.continuingEffectOptions,
                valueExpr: 'value',
                displayExpr: 'display'
            }
        })
    }
    if (fields.Comments.visible) {
        formFields.push({
            caption: fields.Comments.label,
            dataField: 'quotecomment',
            required: fields.Comments.required,
            dataType: 'long-string',
        })
    }
    if (fields.PriceEffect.visible) {
        formFields.push({
            caption: fields.PriceEffect.label,
            dataField: 'amount',
            required: fields.PriceEffect.required,
            dataType: 'money',
        })
    }


    if (fields.DateEffectOptions.visible) {
        formFields.push({
            caption: fields.DateEffectOptions.label,
            dataField: 'effect',
            required: fields.DateEffectOptions.required,
            dataType: 'list',
            options: {
                dataSource: fields.DateEffectOptions.quoteImpactOptions,
                valueExpr: 'field',
                displayExpr: 'display'
            }
        })
    }
    if (fields.ProgrammeDetails.visible) {
        formFields.push({
            caption: fields.ProgrammeDetails.label,
            dataField: 'effecttoprogrammitigatedcomment',
            required: false,
            dataType: 'long-string',
        })
    }
    if (fields.DateEffect.visible) {
        formFields.push({
            caption: fields.DateEffect.label,
            dataField: 'days',
            required: false,
            dataType: 'integer',
        })
    }

    if (fields.AttachedProgramme.visible) {
        formFields.push({
            caption: fields.AttachedProgramme.label,
            dataField: 'attachedprogramme',
            required: false,
            dataType: 'list',
            options: {
                dataSource: fields.AttachedProgramme.options,
            }
        })
    }





    if (replyFields.ReplyStatus.visible) {
        formFields.push({
            caption: replyFields.ReplyStatus.label,
            dataField: 'responsestatus',
            required: replyFields.ReplyStatus.required,
            dataType: 'integer',//'list', //#TODO: fix this to use list
            // options: {
            //     dataSource: replyFields.ReplyStatus.replyOptions,
            //     valueExpr: 'field',
            //     displayExpr: 'field' //#TODO: fix this to use display field
            // },
            isReplyField: true
        })
    }

    if (replyFields.ReplyComment.visible) {
        formFields.push({
            caption: replyFields.ReplyComment.label,
            dataField: 'responsecomment',
            required: replyFields.ReplyComment.required,
            dataType: 'long-string',
            isReplyField: true
        })
    }

    return formFields;
}

class QuoteListPage extends BaseListPage {
    constructor(props) {
        super(props);
        this.quoteStatuses = props.placeholders
            .find(ph => ph.replacementKey === 'QuoteStatuses')
            .values.filter(item => item.isActive === true);

        if (this.props.workflowItem.replyingParty !== "PM") {
            this.responseRequiredDateCaption = this.props.intl.formatMessage({ id: 'CONTRACT.WF.COMPENSATION.FIELD.RESPONSE_REQUIRED' })
            this.responseReceivedDateCaption = this.props.intl.formatMessage({ id: 'CONTRACT.WF.COMPENSATION.FIELD.RESPONSE_RECEIVED' })
        }
        else {
            this.responseRequiredDateCaption = this.props.intl.formatMessage({ id: 'CONTRACT.WF.COMPENSATION.FIELD.PM_RESPONSE_REQUIRED' }, { PM_ABBREVIATION: this.props.globalResources.PM_ABBREVIATION })
            this.responseReceivedDateCaption = this.props.intl.formatMessage({ id: 'CONTRACT.WF.COMPENSATION.FIELD.PM_RESPONSE_RECEIVED' }, { PM_ABBREVIATION: this.props.globalResources.PM_ABBREVIATION })
        }


        this.customFields = [];
        if (props.customFieldsCommon) {
            if (props.customFieldsCommon.QUOTE && props.customFieldsCommon.QUOTE.length > 0) {
                this.customFields.push(...(props.customFieldsCommon.QUOTE.filter(cf => cf.includelisting)));
            }
            if (props.customFieldsCommon.QUOTE_REPLY && props.customFieldsCommon.QUOTE_REPLY.length > 0) {
                this.customFields.push(...(props.customFieldsCommon.QUOTE_REPLY.filter(cf => cf.includelisting)));
            }
        }
        this.continuingEffectOptions = [
            { value: 1, display: this.props.intl.formatMessage({ id: 'OPTIONS.CONTINUING_EFFECT.INTERIM' }) },
            { value: 0, display: this.props.intl.formatMessage({ id: 'OPTIONS.CONTINUING_EFFECT.FINAL' }) },
        ];
        this.batchFormFields = getBatchFormFields(this.props.workflowItem.fields, this.props.workflowItem.replyFields, this.props.intl);
        this.state = {
            notifications: null,
        };
    }
    formatCurrency = () => {

        return this.props.contract.currency
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchQuotes();
    }
    componentDidUpdate(prevprops, prevSatate) {
        if (this.props.params.notificationid !== prevprops.params.notificationid) {
            this.fetchQuotes();
        }
    }
    fetchQuotes = async () => {
        try {
            const { companyid, contractid } = this.props.contract;
            const { data: responseObj } = await quotationCrud.getQuotesReduced(companyid, contractid, this.props.params.notificationid);
            let quotes = (this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed === true) ?
                responseObj :
                responseObj.filter(quo => quo.showtasknotification === 1);
            quotes = CustomFieldHelper.MapDataListCustomFieldsToObjectProperties(quotes);
            this.setState({ notifications: quotes });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }
    calculateUrl = (rowData, skipHostUrl) => {
        return (skipHostUrl ? '' : process.env.PUBLIC_URL) + this.props.workflowItem.paths.basePath + rowData.quotationid;
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = getQuoteBadgeVariantByStatus(cellInfo.data.showtasknotification, cellInfo.data.responsestatus);
        let status = this.renderStatusDisplay(cellInfo.data);
        return (<Badge variant={badgeVariant}>{status}</Badge>);
    }
    renderStatusDisplay = (rowData) => {
        let resourceKey;
        if (rowData.showtasknotification === 1) {
            resourceKey = rowData.responsestatus.toString();
        } else {
            resourceKey = 'none';
        }
        const status = this.quoteStatuses.find(x => x.field === resourceKey);
        if (status) {
            return status.display;
        } else {
            return rowData.status;
        }
    }

    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }
        const { fields } = this.props.workflowItem;


        const columns = [
            { resource: "GENERAL.FORMS.FIELD.ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { resource: "GENERAL.FORMS.FIELD.COMPENSATION_ID", dataField: "compensationreference", dataType: 'string' },
            { resource: "GENERAL.FORMS.FIELD.DAYS", dataField: 'days' },
            { resource: "GENERAL.FORMS.FIELD.AMOUNT", dataField: 'amount', dataType: 'currency', currencyCode: this.props.contract.currency },
            { resource: "CONTRACT.WF.QUOTES.FIELD.QUOTE_DATE", dataField: "notificationdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.ISSUED_BY", dataField: "communicatedby" },
            { caption: this.responseRequiredDateCaption, dataField: "responsedate", dataType: 'date' },
            { caption: this.responseReceivedDateCaption, dataField: "responseresponsedate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "responsestatus", cellRender: this.renderStatusColumn, calculateCellValue: this.renderStatusDisplay },
            { resource: "GENERAL.FORMS.FIELD.REPLY_DRAFT_BY", dataField: "draftreplyby", visible: false },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
            { resource: "GENERAL.FORMS.FIELD.CURRENCY", dataField: "currency", visible: false, calculateCellValue: this.formatCurrency },
            { resource: "PROJECT.FIELD.CODE", dataField: "projectcode", visible: false },
            { resource: "PROJECT.FIELD.NAME", dataField: "project", visible: false },
            { resource: "GENERAL.FORMS.REPLING_PARTY", dataField: "replyingparty", lookup: { dataSource: this.props.contractTemplate.parties.options, valueExpr: 'id', displayExpr: 'display' }, visible: false },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby", visible: false },
            { resource: "GENERAL.FORMS.FIELD.REPLY_CREATED_BY", dataField: "replycreatebyname", visible: false },
            { resource: "GENERAL.FORMS.FIELD.DRAFT_NOTIFIED_TO", dataField: "lastdraftednotifiedtoname", visible: false },
            { resource: "GENERAL.FORMS.FIELD.REPLY_DRAFT_NOTIFIED_TO", dataField: "lastreplydraftednotifiedtoname", visible: false },

        ];
        if (this.props.globalResources.QUOTE_DEEMED_ACCEPTANCE_STARTS !== 'OFF') {
            columns.push(
                { resource: "CONTRACT.WF.COMPENSATION.FIELD.QUOTE_DEEM_DATE", dataField: "quotedeemedacceptancedate", dataType: 'date' }
            );
        }

        if (fields.ContinuingEffect.visible) {
            columns.push(
                { resource: "GENERAL.FORMS.EFFECT", dataField: "continuingeffect", lookup: { dataSource: this.continuingEffectOptions, valueExpr: 'value', displayExpr: 'display' }, visible: false }
            );
        }

        columns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(this.customFields));
        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="1"
                        //BATCH OPS
                        batchOperations={true}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={quotationCrud.importQuotations}
                        batchDeleteEndpoint={quotationCrud.deleteQuotationDrafts}
                        batchCommunicateEndpoint={quotationCrud.communicateQuotationDrafts}
                        onBatchRecordsUpdated={this.fetchQuotes}
                        customFields={this.props.customFields}
                        //BATCH OPS
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        createPath={(this.props.workflowItem.userFilters.mainNotice.createAllowed && this.props.baseNotificationReadyForCreate) ? this.props.workflowItem.paths.createPath : null}
                        workflowItem={this.props.workflowItem}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="quotationid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={columns}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}



export default withListPageProps(QuoteListPage);
